import React, { Component } from "react";
import "./PickListItemDetailWarningModal.scss";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";

type Props = {
    closeModal: (markIssue?: boolean) => void;
};

type State = {};

export default class PickListItemDetailWarningModal extends Component<Props, State> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {}

    componentWillUnmount(): void {}

    render() {
        return (
            <div className={"PickListItemDetailWarningModal"}>
                <div className={"row"}>
                    <div className={"col-12"}>
                        <OwTitle title={"partial_pick"} tag={"h4"} />

                        <OwLabel title={"partial_pick_mark_issue_or_proceed"} />

                        <div className={"d-flex"}>
                            <div>
                                <OwButton
                                    btnSizeClass={"btn-lg"}
                                    title={"mark_issue"}
                                    fn={() => {
                                        this.props.closeModal(true);
                                    }}
                                />
                            </div>
                            <div>
                                <OwButton
                                    btnSizeClass={"btn-lg"}
                                    className={"ms-2 btn-warning"}
                                    title={"proceed"}
                                    fn={() => {
                                        this.props.closeModal(false);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
